// @ts-nocheck
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../hooks';
import { removeFromGroup } from '../middleware/signalRMiddleware';

const useUploadNotificationsSingle = (
  groupPrefix,
  importTransactions,
  found
) => {
  const dispatch = useAppDispatch();
  const [uploadsInProgress, setUploadsInProgress] = useState([]);

  useEffect(() => {
    //clear subscriptions
    if (uploadsInProgress && uploadsInProgress.length > 0) {
      return () => {
        let uploads = [];
        for (let i in uploadsInProgress) {
          uploads.push(
            dispatch(removeFromGroup(`${groupPrefix}:${uploadsInProgress[i]}`))
          );
        }
        return Promise.all(uploads);
      };
    }
  }, [uploadsInProgress, groupPrefix, dispatch]);

  useEffect(() => {
    if (
      importTransactions &&
      importTransactions.length > 0 &&
      importTransactions.filter((x) => uploadsInProgress.includes(x.id))
        .length > 0
    ) {
      found(importTransactions.filter((x) => uploadsInProgress.includes(x.id)));
    }
  }, [importTransactions, uploadsInProgress, found]);

  return [uploadsInProgress, setUploadsInProgress];
};
export default useUploadNotificationsSingle;
